import React from "react";
import ReactECharts from "echarts-for-react";
import { Spin, Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface PlannedVsDeviationLineChartProps {
  loading: boolean;
  chartData: {
    months: string[];
    planned: number[];
    deviation: number[];
  } | null;
}

const PlannedVsDeviationLineChart: React.FC<
  PlannedVsDeviationLineChartProps
> = ({ loading, chartData }) => {
  const getChartOptions = () => {
    if (!chartData) return {};

    return {
      animationDuration: 1000,
      tooltip: {
        trigger: "axis",
      },
      grid: {
        top: 45,
        bottom: 50,
        left: 30,
        right: 20,
        containLabel: true,
      },
      legend: {
        data: ["Planned", "Deviation"],
        top: 5,
        left: "center",
      },
      xAxis: {
        type: "category",
        data: chartData.months,
        name: "By Month",
        nameLocation: "middle",
        nameGap: 30,
        axisLabel: {
          fontSize: 11,
        },
      },
      yAxis: {
        type: "value",
        name: "% Deviation",
        nameLocation: "middle",
        nameGap: 40,
        axisLabel: {
          fontSize: 11,
        },
      },
      series: [
        {
          name: "Planned",
          type: "line",
          smooth: true,
          data: chartData.planned,
          lineStyle: {
            color: "#1890ff",
          },
          itemStyle: {
            color: "#1890ff",
          },
        },
        {
          name: "Deviation",
          type: "line",
          smooth: true,
          data: chartData.deviation,
          lineStyle: {
            color: "#f5222d",
          },
          itemStyle: {
            color: "#f5222d",
          },
        },
      ],
    };
  };
  if (loading) {
    return (
      <div
        style={{
          height: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  if (!chartData || !chartData.months || chartData.months.length === 0) {
    return (
      <div
        style={{
          height: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="No data found" />
      </div>
    );
  }

  return (
    <ReactECharts
      style={{ height: 300, width: "100%" }}
      option={getChartOptions()}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default PlannedVsDeviationLineChart;
